import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { PrivateRouters } from './PrivateRouters';
import { Login } from '../pages/Login';
import { Profile } from '../pages/Profile';
import { NoMath } from '../pages/NoMath';
import { Layout } from '../components/Layout';
import { LayoutAuth } from '../components/LayoutAuth';
import { Home } from '../pages/Home';
import { PatchesName } from '../helpers/types';
import { useHandlerNotificationApp } from '../hooks/useHandlerNotificationApp';

export const AppRouter = () => {
  useHandlerNotificationApp();
  const { pathname } = useLocation();
  return (
    <Routes>
      <Route path="/" element={<PrivateRouters />}>
        <Route element={<Layout path={pathname} />}>
          <Route path="/" element={<Navigate to={`/${PatchesName.Profile}`} />} />
          <Route path={`/${PatchesName.Profile}`} element={<Profile />} />
          <Route path={PatchesName.Home} element={<Home />} />
        </Route>
      </Route>
      <Route element={<LayoutAuth />}>
        <Route path={`/${PatchesName.Login}`} element={<Login />} />
      </Route>
      <Route path="*" element={<NoMath />} />
    </Routes>
  );
};
